import { Group, TextInput, Text } from "@mantine/core";
import { AlertTriangle } from "lucide-react";
import { handleWarning } from "../utils";

export interface StudentFormData {
  last_name: string;
  first_name: string;
  middle_name: string;
  phystech_email: string;
  gmail: string;
  vk_id: string;
  mipt_tech_tag: string;
}

export const toStudentFormData = (s: any): StudentFormData => ({
  last_name: s.last_name || "",
  first_name: s.first_name || "",
  middle_name: s.middle_name ?? "",
  phystech_email: s.phystech_email || "",
  gmail: s.gmail ?? "",
  vk_id: s.vk_id ?? "",
  mipt_tech_tag: s.mipt_tech_tag ?? "",
});

export const fromStudentFormData = (f: StudentFormData) => ({
  last_name: f.last_name.trim(),
  first_name: f.first_name.trim(),
  middle_name: f.middle_name.trim() || null,
  gmail: f.gmail.trim() || null,
  vk_id: f.vk_id.trim() || null,
  mipt_tech_tag: f.mipt_tech_tag.trim() || null,
});

export function StudentFormFields({ form, onChange, disableEmail = false }: {
  form: StudentFormData; onChange: (updater: (prev: StudentFormData) => StudentFormData) => void; disableEmail?: boolean;
}) {
  const setField = (key: keyof StudentFormData, val: string) => onChange(f => ({ ...f, [key]: val }));

  return (
    <>
      <Group grow>
        <TextInput label="Фамилия" required value={form.last_name} onChange={e => setField("last_name", e.target.value)} />
        <TextInput label="Имя" required value={form.first_name} onChange={e => setField("first_name", e.target.value)} />
      </Group>
      <TextInput label="Отчество" value={form.middle_name} onChange={e => setField("middle_name", e.target.value)} />
      <TextInput label="Физтех-почта" required disabled={disableEmail} value={form.phystech_email} onChange={e => setField("phystech_email", e.target.value)} />
      <TextInput label="Gmail" value={form.gmail} onChange={e => setField("gmail", e.target.value)} />
      <div>
        <TextInput label="VK" value={form.vk_id} onChange={e => setField("vk_id", e.target.value)} />
        {handleWarning(form.vk_id) && <Group gap={4} wrap="nowrap" mt={4}><AlertTriangle size={13} color="var(--mantine-color-yellow-6)" /><Text c="yellow" fz="xs">{handleWarning(form.vk_id)}</Text></Group>}
      </div>
      <div>
        <TextInput label="mipt.tech" value={form.mipt_tech_tag} onChange={e => setField("mipt_tech_tag", e.target.value)} />
        {handleWarning(form.mipt_tech_tag) && <Group gap={4} wrap="nowrap" mt={4}><AlertTriangle size={13} color="var(--mantine-color-yellow-6)" /><Text c="yellow" fz="xs">{handleWarning(form.mipt_tech_tag)}</Text></Group>}
      </div>
    </>
  );
}
